// URL PARAMS
const urlParams = new URLSearchParams(window.location.search);
const defaultAvatarType = 'gptCEU';
export const avatarType = urlParams.get('avatar') || defaultAvatarType;
export const usuario = urlParams.get('usuario');

export const getUrlDominio = (): string | null =>
  decodeURIComponent(window.location.pathname).replace(/^\/+/, '').replace(/\/+$/, '') || null;

// ✅ Configuración fija para España (ES)
export const apiUrl = process.env.REACT_APP_GPT_CEU_API_ES;
export const currentEndpoint = 'ES';

// AZURE SPEECH
export const SPEECH_REGION = 'westeurope';
export const SPEECH_REGION_REPLACE = 'SPEECH_REGION';
export const VOLUMEN_ON = true;
export const VOLUMEN_OFF = false;

// OTHERS
export const FILE_NAME_MAX_LENGTH = 10;
export const DESARROLLO_MODE = 'des';
